import anaConsts from 'analytics/constants';
import processEvent from 'analytics/processEvent';
import { PRS_EVENTS } from 'ai/analytics/events';

const {
    SOT_LINK_TRACKING_EVENT,
    ASYNC_PAGE_LOAD
} = anaConsts;

const REVIEWS = 'reviews';

const triggerSOTAnalytics = ({ eventName, ...data }) => {
    processEvent.process(SOT_LINK_TRACKING_EVENT, {
        data: {
            linkName: eventName,
            actionInfo: eventName,
            specificEventName: eventName,
            sotType: eventName,
            ...data
        }
    });
};

const triggerSOTAsyncAnalytics = ({ ...data }) => {
    processEvent.process(ASYNC_PAGE_LOAD, { data });
};

export const trackPRSSummaryImpression = ({ productId }) => {
    triggerSOTAsyncAnalytics({
        pageDetail: PRS_EVENTS.SUMMARY_MODULE,
        pageName: `${REVIEWS}:${PRS_EVENTS.SUMMARY_MODULE}:n/a:*`,
        pageType: REVIEWS,
        sotV55: PRS_EVENTS.SUMMARY_IMPRESSION,
        productId
    });
};

export const trackAspectChipClick = ({ aspectName, count, type, productId }) => {
    triggerSOTAnalytics({
        eventName: PRS_EVENTS.ASPECT_CHIP_CLICK,
        sotV55: `prs:aspect:${aspectName}:count ${count}`,
        productId,
        sentimentType: type
    });
};

export const trackRatingFilterClick = ({ ratingValue, productId }) => {
    triggerSOTAnalytics({
        eventName: PRS_EVENTS.RATING_FILTER_CLICK,
        sotV55: `prs:rating:${ratingValue}`,
        productId
    });
};

export const trackWriteReviewClick = ({ productId, uiVariant }) => {
    triggerSOTAnalytics({
        eventName: PRS_EVENTS.WRITE_REVIEW_CLICK,
        sotV55: 'prs:write_review',
        productId,
        uiVariant
    });
};

export const trackErrorOrEmptyState = ({ productId, errorType }) => {
    const pageDetail = errorType === 'error' ? PRS_EVENTS.SUMMARY_ERROR : PRS_EVENTS.SUMMARY_EMPTY;

    triggerSOTAsyncAnalytics({
        pageDetail,
        pageName: `${REVIEWS}:${pageDetail}:n/a:*`,
        pageType: REVIEWS,
        sotV55: `prs:${errorType}`,
        productId
    });
};
